export const normalizePhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.length === 10 ? `1${digits}` : digits;
};

export const whatsappLink = (phone, message) =>
  `https://wa.me/${normalizePhone(phone)}?text=${encodeURIComponent(message)}`;

export const smsLink = (phone, message) =>
  `sms:+${normalizePhone(phone)}?&body=${encodeURIComponent(message)}`;

export const money = (v) => (v ? `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}` : '—');

export const shortDate = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '—');

export const GROUP_STYLES = {
  Hot: 'bg-red-50 text-red-700 border-red-200',
  'Most Active': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Cold: 'bg-slate-100 text-slate-600 border-slate-200',
  'No History': 'bg-gray-50 text-gray-400 border-gray-200',
};

export const defaultTextMessage = (lead) => lead
  ? 'Hi {{first_name}}, I have an off-market deal at {{property_address}} for {{price}}. Want the details?'
  : 'Hi {{first_name}}, I have new off-market deals coming up. Are you still buying?';

export const defaultEmail = (lead) => lead
  ? { subject: 'Off Market Deal - {{property_address}}', body: 'Hi {{first_name}},\n\nI have an off-market property at {{property_address}} listed at {{price}} that matches what you have been buying.\n\nReply if you want photos and details.\n\nThanks!' }
  : { subject: 'New off-market deals', body: 'Hi {{first_name}},\n\nI have new off-market deals coming up in the areas you buy. Are you still active?\n\nThanks!' };
